export default "__VITE_ASSET__DFGEFz9R__"